import axios from "axios";

import { deleteUserPassengerPath } from "../paths";

export const deleteUserPassenger = async (personId: string) => {
  const res = await axios.post(deleteUserPassengerPath, { personId });

  return res.data;
};
